import {
  RESET_PUSH,
  FETCHING_PUSH,
  FETCH_PUSH_SUCCESS,
  FETCH_PUSH_FAIL,
  POSTING_PUSH,
  POST_PUSH_SUCCESS,
  POST_PUSH_FAIL
  // DELETE_PUSH
  // SENDING_PUSH,
  // SEND_PUSH_SUCCESS,
  // SEND_PUSH_FAIL
} from '../actions/types'

const INITIAL_STATE = {
  loading: false,
  data: [],
  errorMsg: null,
  postSuccess: null
  // sending: false,
  // sendSuccess: null
}

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case RESET_PUSH:
      return { ...state, ...INITIAL_STATE }
    case FETCHING_PUSH:
      return { ...state, loading: true }
    case FETCH_PUSH_SUCCESS:
      return { ...state, ...INITIAL_STATE, data: action.payload }
    case FETCH_PUSH_FAIL:
      return { ...state, ...INITIAL_STATE, errorMsg: action.payload }
    case POSTING_PUSH:
      return { ...state, postSuccess: false, loading: true }
    case POST_PUSH_SUCCESS:
      return { ...state, ...INITIAL_STATE, postSuccess: true }
    case POST_PUSH_FAIL:
      return { ...state, ...INITIAL_STATE, errorMsg: action.payload }
    // case SENDING_PUSH:
    //   return { ...state, sending: true, sendSuccess: null }
    // case SEND_PUSH_SUCCESS:
    //   return { ...state, sending: false, sendSuccess: true }
    // case SEND_PUSH_FAIL:
    //   return { ...state, sending: false, sendSuccess: false }
    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/pushReducer.js